import axios from 'axios';

// export const baseURL = 'http://localhost:3005';
// export const baseURL = 'https://monclock.ngrok.io';
export const baseURL = 'https://clockify.mapps.luxie.tech';

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  timeout: 300000, // 5 mins before timeout
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `${token}`;
  }
  return config;
});

export default axiosInstance;
